import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout, { EmailField } from '../components/AuthLayout';
import { validateEmail } from '../utils/validator';
import request from '../core/request';
import { env } from '../utils/const';
const { REACT_APP_AUTH_API } = process.env

const ForgotPassword = () => {
  const history = useHistory();
  const [state, setState] = useState({
    email: '',
    emailError: '',
  });
  const handleState = (value, key) => {
    setState({ ...state, [key]: value, [key + 'Error']: '' });
  };

  const handleSubmit = async () => {
    console.log(env.REACT_APP_AUTH_API,REACT_APP_AUTH_API,'request');
    let isValid = true;
    let localState = state;
    const emailValidation = validateEmail(state.email);
    if (!emailValidation.isValid) {
      isValid = false;
      localState = { ...localState, emailError: emailValidation.message };
    }
    if (isValid) {
      let { data, status } = await request.post(`/user/forgotpassword`, {
        email: state.email,
      });
      if (status >= 400) {
        toast.error(data.message);
      }
      if (status >= 200 && status < 300) {
        toast.success('Reset password link is sent to your email');
        history.push('/');
      }
    } else {
      setState(localState);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <AuthLayout
      title="Forgot password"
      subtitle="Enter your email and we'll send you a reset link."
      after={
        <p className="signup-line">
          Remembered it?{" "}
          <button type="button" className="link" onClick={() => history.push('/')}>
            Back to sign in
          </button>
        </p>
      }
    >
      <EmailField
        value={state.email}
        error={state.emailError}
        onChange={(value) => handleState(value, 'email')}
        onKeyDown={handleKeyPress}
      />
      <button type="button" className="auth-btn auth-btn-primary auth-btn-block" onClick={handleSubmit}>
        Send reset link
      </button>
    </AuthLayout>
  );
};

export default ForgotPassword;
